import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import Form, { FormProps } from '@/components/Form';

import { DuplicateListEditorFormValues, FORM_LAYOUT, getFormFields, validateForm } from './config';

function Editor({
  setFormikSubmit,
  onSubmit,
  initialValues,
}: {
  setFormikSubmit: FormProps<DuplicateListEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<DuplicateListEditorFormValues>['onSubmit'];
  initialValues: DuplicateListEditorFormValues;
}) {
  const { t } = useTranslation(['Admin', 'Task']);

  return (
    <Form<DuplicateListEditorFormValues>
      fields={getFormFields(t)}
      formName="DuplicateListEditor"
      initialValues={initialValues}
      layout={FORM_LAYOUT}
      setSubmitRef={setFormikSubmit}
      validate={validateForm(t)}
      onSubmit={onSubmit}
    />
  );
}

export default Editor;
